import { createSlice } from "@reduxjs/toolkit";

const initialStateValue = {
  losCustomerData: {},
};
const DisbursementLosCustomerDataReducer = createSlice({
  name: "disbursementLosCustomerData",
  initialState: initialStateValue,
  reducers: {
    resetToInitialState(state, action) {
      state = { ...initialStateValue };
    },
    setLosCustomerData(state, action) {
      state.losCustomerData = { ...action.payload };
    },
  },
});

export const DisbursementLosCustomerDataReducerAction =
  DisbursementLosCustomerDataReducer.actions;
export default DisbursementLosCustomerDataReducer.reducer;
